import { ReactElement, ReactNode } from 'react'
import { getUpdatedAdminLayout } from '../admin/dashboard-layout/newlayout'
import { getDefaultLayout } from '../layout'

interface LayoutWrapperProps {
  children: ReactNode
  type: 'admin' | 'default' | 'none'
}

export const LayoutWrapper = ({ children, type }: LayoutWrapperProps) => {
  switch (type) {
    case 'admin':
      return <>{getUpdatedAdminLayout(children)}</>
    case 'default':
      return <>{getDefaultLayout(children as ReactElement)}</>
    default:
      return <>{children}</>
  }
}
